export const templatesTranslation = {
  en: {
    "Template Name": "Template Name",
    "User Name": "User Name",
    "Folder Name": "Folder Name",
    "Link": "Link",
    "Is Archived": "Is Archived",
    "Updated At": "Updated At",
    "Created At": "Created At",
    "Actions": "Actions",
    "Search": "Search",
    "Home": "Home",
    "Templates": "Templates",
    "All Templates": "All Templates",
    "Archived Templates": "Archived Templates",
    "Delete Confirmation": "Are you sure you want to delete'?",
    "Delete Warning": "This action cannot be undone.",
    "Cancel": "Cancel",
    "Delete": "Delete",
    "Choose date range for templates": "Choose date range for templates",
    "Template token copied to clipboard!": "Template token copied to clipboard!",
    "Failed to copy template token": "Failed to copy template token",
    "Template Token": "Template Token",
    "Is Cloned": "Is Cloned",
    "Parent Folder ": "Parent Folder ",
    "Current Folder ": "Current Folder ",
    "Teams": "Teams",
    "Not available": "Not available",
    "Copy UUID": "Copy UUID",
    "Copy Template Token": "Copy Template Token",
    "View Recipients of Template": "View Recipients of Template",
    "View Preferences": "View Preferences",
    "View Parties of Submission": "View Parties of Submission",
    "Recipients": "Recipients",
    "Party": "Party",
    "Name": "Name",
    "Email": "Email",
    "Phone": "Phone",
    "Role": "Role",
    "No recipients found.": "No recipients found.",
    "Preferences": "Preferences",
    "Preference": "Preference",
    "Type": "Type",
    "Completed Documents Notification BCC": "Completed Documents Notification BCC",
    "Expiry Date Extend Setting": "Expiry Date Extend Setting",
    "Template Public ID": "Template Public ID",
    "User Public ID": "User Public ID",
    "Preference ID": "Preference ID",
    "Preference Options": "Preference Options",
    "Preference Option ID": "Preference Option ID",
    "Redirect on Completion URL": "Redirect on Completion URL",
    "Completion Message": "Completion Message",
    "Signature Request Email Subject": "Signature Request Email Subject",
    "Signature Request Email Body": "Signature Request Email Body",
    "Documents Copy Email Subject": "Documents Copy Email Subject",
    "Documents Copy Email Body": "Documents Copy Email Body",
    "Completed Notification Email": "Completed Notification Email",
    "Completed Notification Subject": "Completed Notification Subject",
    "Attached Document": "Attached Document",
    "Attached Audit": "Attached Audit",
    "Send Email": "Send Email",
    "Deleted At": "Deleted At",
    "Document Copy Email Send Email Completion": "Document Copy Email Send Email Completion",
    "Notification Email Attach Document To Email": "Notification Email Attach Document To Email",
    "Notification Email Attach Audit Log PDF To Email": "Notification Email Attach Audit Log PDF To Email",
    "Notification Email Send Email Completion": "Notification Email Send Email Completion",
    "No preference data found.": "No preference data found.",
    "Parties of Submission": "Parties of Submission",
    "Parties of submission will be shown here.": "Parties of submission will be shown here.",
    "search": "Search",
    "Clear": "Clear",
    "Close": "Close",
    "Unknown Party": "Unknown Party",
    "Tool": "Tool",
    "Tool Type": "Tool Type",
    "Title": "Title",
    "Details": "Details",
    "Condition": "Condition",
    "Field Title": "Field Title",
    "Field Value": "Field Value",
    "Description": "Description",
    "Display Title": "Display Title",
    "Formula": "Formula",
    "Signing Date": "Signing Date",
    "With Logo": "With Logo",
    "Text": "Text",
    "Required": "Required",
    "Read Only": "Read Only",
    "Yes": "Yes",
    "No": "No",
    "No details found.": "No details found.",
    "No party data found.": "No party data found.",
    "Enable Share Link": "Enable Share Link",
    "Add New": "Add New",
    "Apply Order": "Apply Order",
    "Completed documents notification BCC": "Completed documents notification BCC",
    "Form preferences": "Form preferences",
    "Redirect on completion URL": "Redirect on completion URL",
    "Completion message": "Completion message",
    "Signature request email": "Signature request email",
    "Body": "Body",
    "Write your message here": "Write your message here",
    "Documents copy email": "Documents copy email",
    "Attach Document to email": "Attach Document to email",
    "Attach Audit log PDF to the email": "Attach Audit log PDF to the email",
    "Send email automatically on completion": "Send email automatically on completion",
    "Subject": "Subject",
    "Completed notification email": "Completed notification email",
   "Enter.....": "Enter.....",
   "Party Name": "Party Name",
   "Add Tool": "Add Tool",
   "Parties updated successfully!": "Parties updated successfully!",
   "Preferences saved successfully": "Preferences saved successfully!",
   "Recipients updated successfully!": "Recipients updated successfully!",
   "Order No": "Order No",
   "Order": "Order",
   "Select Order": "Select Order",
   "Signer": "Signer",
   "Viewer": "Viewer",
   "Width": "Width",
   "Height": "Height",
   "Page Number": "Page Number",
   "Pages": "Pages",
   "Number of column": "Number of column",
    "Party Color": "Party Color",
    "Copy to all pages": "Copy to all pages",
    "Format": "Format",
    "Align": "Align",
    "Regex": "Regex",
    "Logical Operator": "Logical Operator",
    "Empty" : "Empty",
    "Not empty" : "Not empty",
    "Equal" : "Equal",
    "Not equal" : "Not equal",
    "Enter validation regex" : "Enter validation regex",
    "Parallel" : "Parallel",
    "Sequential" : "Sequential",
    "Parties of Template" : "Parties of Template",
    "Font Bold" : "Font Bold",
    "Font Italic" : "Font Italic",
    "Set Signing Date": "Set Signing Date",
     "Signature Format": "Signature Format",
    "Date Format": "Date Format",
    "Number Format": "Number Format",
    "Validation": "Validation",
    "Number Min": "Number Min",
    "Number Max": "Number Max",
    "Error Message": "Error Message",
    "Enter Formula": "Enter Formula",
    "Font Size": "Font Size",
    "Font Name": "Font Name",
    "Font Align Vertical": "Font Align Vertical",
    "Font Align Horizontal": "Font Align Horizontal",
    "Font Color": "Font Color",
    "Payment Currency": "Payment Currency",
    "Payment Amount": "Payment Amount",
    "Payment Price": "Payment Price",
    "Payment Link": "Payment Link",
    "Payment Quantity": "Payment Quantity",
    "Default Value": "Default Value",
    "Options (radio/multiple)": "Options (radio/multiple)",
    "Regix": "Regex",
    "Add Option": "Add Options",
    "Left": "Left",
    "Center": "Center",
    "Right": "Right",
    "Top": "Top",
    "Middle": "Middle",
    "Bottom": "Bottom",
    "Black": "Black",
    "Blue": "Blue",
    "Red": "Red",
    "White": "White",
    "Green": "Green",
    "One-off": "One-off",
    "Contains": "Contains",
    "Does not contain": "Does not contain",
    "Default" : "Default",
    "Cell Validation": "Cell Validation",
    "Cell Align": "Cell Align",
    "Payment Formula": "Payment Formula",
    "Draw": "Draw",
    "Options (Radio)": "Options (Radio)",
    "Options (Multiple)": "Options (Multiple)",
    "Add": "Add",
    "Use following placeholders text: {template.name}, {submitter.link}, {account.name}": "Use following placeholders text: {template.name}, {submitter.link}, {account.name}",
    "Verify Status": "Verify Status",
    "Add Radio": "Add Radio",
    "Add Multiple": "Add Multiple",
    "Activity Type": "Activity Type",
    "Browser": "Browser",
    "Change Type": "Change Type",
    "No other fields": "No other fields",
    "Page Width": "Page Width",
    "Page Height": "Page Height",
  },

  ar: {
    "Template Name": "اسم القالب",
    "User Name": "اسم المستخدم",
    "Folder Name": "اسم المجلد",
    "Link": "رابط",
    "Is Archived": "مؤرشف",
    "Updated At": "تاريخ التحديث",
    "Created At": "تاريخ الإنشاء",
    "Actions": "إجراءات",
    "Search": "بحث",
    "Home": "الرئيسية",
    "Templates": "القوالب",
    "All Templates": "جميع القوالب",
    "Archived Templates": "القوالب المؤرشفة",
    "Delete Confirmation": "هل أنت متأكد أنك تريد حذف '{{name}}'؟",
    "Delete Warning": "لا يمكن التراجع عن هذا الإجراء.",
    "Cancel": "إلغاء",
    "Delete": "حذف",
    "Choose date range for templates": "اختر نطاق التاريخ للقوالب",
    "Template token copied to clipboard!": "تم نسخ رمز القالب إلى الحافظة!",
    "Failed to copy template token": "فشل في نسخ رمز القالب",
    "Template Token": "رمز القالب",
    "Is Cloned": "منسوخ",
    "Parent Folder ": "المجلد الرئيسي ",
    "Current Folder ": "المجلد الحالي ",
    "Teams": "الفرق",
    "Not available": "غير متوفر",
    "Copy UUID": "نسخ UUID",
    "Copy Template Token": "نسخ رمز القالب",
    "View Recipients of Template": "عرض مستلمي القالب",
    "View Preferences": "عرض التفضيلات",
    "View Parties of Submission": "عرض أطراف التقديم",
    "Recipients": "المستلمون",
    "Party": "طرف",
    "Name": "الاسم",
    "Email": "البريد الإلكتروني",
    "Phone": "الهاتف",
    "Role": "الدور",
    "No recipients found.": "لم يتم العثور على مستلمين.",
    "Preferences": "التفضيلات",
    "Preference": "تفضيل",
    "Type": "النوع",
    "Completed Documents Notification BCC": "نسخة مخفية من إشعار المستندات المكتملة",
    "Expiry Date Extend Setting": "إعداد تمديد تاريخ الانتهاء",
    "Template Public ID": "معرف القالب العام",
    "User Public ID": "معرف المستخدم العام",
    "Preference ID": "معرف التفضيل",
    "Preference Options": "خيارات التفضيل",
    "Preference Option ID": "معرف خيار التفضيل",
    "Redirect on Completion URL": "إعادة التوجيه عند الاكتمال",
    "Completion Message": "رسالة الاكتمال",
    "Signature Request Email Subject": "موضوع بريد طلب التوقيع",
    "Signature Request Email Body": "محتوى بريد طلب التوقيع",
    "Documents Copy Email Subject": "موضوع بريد نسخة المستندات",
    "Documents Copy Email Body": "محتوى بريد نسخة المستندات",
    "Completed Notification Email": "بريد إشعار الاكتمال",
    "Completed Notification Subject": "موضوع إشعار الاكتمال",
    "Attached Document": "مستند مرفق",
    "Attached Audit": "تدقيق مرفق",
    "Send Email": "إرسال بريد إلكتروني",
    "Deleted At": "تاريخ الحذف",
    "Document Copy Email Send Email Completion": "إرسال بريد نسخة المستندات عند الاكتمال",
    "Notification Email Attach Document To Email": "إرفاق المستند بالبريد في إشعار البريد",
    "Notification Email Attach Audit Log PDF To Email": "إرفاق سجل التدقيق PDF بالبريد في إشعار البريد",
    "Notification Email Send Email Completion": "إرسال البريد عند اكتمال إشعار البريد",
    "No preference data found.": "لم يتم العثور على بيانات تفضيل.",
    "Parties of Submission": "أطراف التقديم",
    "Parties of submission will be shown here.": "سيتم عرض أطراف التقديم هنا.",
    "search": "بحث",
    "Clear": "مسح",
    "Close": "إغلاق",
    "Unknown Party": "طرف غير معروف",
    "Tool": "أداة",
    "Tool Type": "نوع الأداة",
    "Title": "العنوان",
    "Details": "التفاصيل",
    "Condition": "شرط",
    "Field Title": "عنوان الحقل",
    "Field Value": "قيمة الحقل",
    "Description": "الوصف",
    "Display Title": "عنوان العرض",
    "Formula": "معادلة",
    "Signing Date": "تاريخ التوقيع",
    "With Logo": "مع الشعار",
    "Text": "النص",
    "Required": "مطلوب",
    "Read Only": "للقراءة فقط",
    "Yes": "نعم",
    "No": "لا",
    "No details found.": "لا توجد تفاصيل.",
    "No party data found.": "لا توجد بيانات للأطراف.",
    "Enable Share Link": "تمكين رابط المشاركة",
    "Add New": "إضافة جديد",
    "Apply Order": "تطبيق الترتيب",
    "Completed documents notification BCC": "نسخة مخفية من إشعار المستندات المكتملة",
    "Form preferences": "تفضيلات النموذج",
    "Redirect on completion URL": "إعادة التوجيه عند اكتمال الرابط",
    "Completion message": "رسالة الاكتمال",
    "Signature request email": "بريد طلب التوقيع",
    "Body": "المحتوى",
    "Subject": "الموضوع",
    "Write your message here": "اكتب رسالتك هنا",
    "Documents copy email": "بريد نسخة المستندات",
    "Attach Document to email": "إرفاق المستند بالبريد",
    "Attach Audit log PDF to the email": "إرفاق سجل التدقيق PDF بالبريد",
    "Send email automatically on completion": "إرسال البريد تلقائيًا عند الاكتمال",
    "Completed notification email": "بريد إشعار الاكتمال",
    "Enter.....": "أدخل.....",
    "Party Name": "اسم الطرف",
    "Add Tool": "إضافة أداة",
    "Parties updated successfully!": "تم تحديث الأطراف بنجاح!",
    "Preferences saved successfully": "تم حفظ التفضيلات بنجاح!",
    "Recipients updated successfully!": "تم تحديث المستلمين بنجاح!",
    "Order No": "رقم الترتيب",
    "Order": "نوع الترتيب",
    "Select Order": "اختر نوع الترتيب",
    "Signer": "موقع",
    "Viewer": "عارض",
    "Width": "العرض",
    "Height": "الارتفاع",
    "Page Number": "رقم الصفحة",
    "Pages": "الصفحات",
    "Number of column": "عدد الأعمدة",
    "Party Color": "لون الطرف",
    "Copy to all pages": "نسخ إلى جميع الصفحات",
    "Format": "التنسيق",
    "Align": "محاذاة",
    "Regex": "تعابير نمطية",
    "Logical Operator": "المشغل المنطقي",
    "Empty" : "فارغ",
    "Not empty" : "غير فارغ",
    "Equal" : "مساوي",
    "Not equal" : "غير مساوي",
    "Enter validation regex" : "أدخل تعبير نمطي للتحقق",
    "Parallel" : "متوازي",
    "Sequential" : "تتابعي",
    "Parties of Template" : "أطراف القالب",
    "Font Bold" : "خط عريض",
    "Font Italic" : "خط مائل",
    "Set Signing Date": "تعيين تاريخ التوقيع",
      "Signature Format": "تنسيق التوقيع",
    "Date Format": "تنسيق التاريخ",
    "Number Format": "تنسيق الرقم",
    "Validation": "التحقق",
    "Number Min": "الحد الأدنى للرقم",
    "Number Max": "الحد الأقصى للرقم",
    "Error Message": "رسالة الخطأ",
    "Enter Formula": "أدخل المعادلة",
    "Font Size": "حجم الخط",
    "Font Name": "اسم الخط",
    "Font Align Vertical": "محاذاة الخط عموديًا",
    "Font Align Horizontal": "محاذاة الخط أفقيًا",
    "Font Color": "لون الخط",
    "Payment Currency": "عملة الدفع",
    "Payment Amount": "مبلغ الدفع",
    "Payment Price": "سعر الدفع",
    "Payment Link": "رابط الدفع",
    "Payment Quantity": "كمية الدفع",
    "Default Value": "القيمة الافتراضية",
    "Options (radio/multiple)": "خيارات (راديو/متعددة)",
    "Regix": "تعابير نمطية",
    "Add Option": "إضافة خيار",
    "Left": "يسار",
    "Center": "وسط",
    "Right": "يمين",
    "Top": "أعلى",
    "Middle": "منتصف",
    "Bottom": "أسفل",
    "Black": "أسود",
    "Blue": "أزرق",
    "Red": "أحمر",
    "White": "أبيض",
    "Green": "أخضر",
    "One-off": "مرة واحدة",
    "Contains": "يحتوي على",
    "Does not contain": "لا يحتوي على",
    "Default" : "افتراضي",
    "Cell Validation": "تحقق الخلية",
    "Cell Align": "محاذاة الخلية",
    "Payment Formula": "معادلة الدفع",
    "Draw": "رسم",
    "Options (Radio)": "خيارات (راديو)",
    "Options (Multiple)": "خيارات (متعددة)",
    "Add": "إضافة",
    "Use following placeholders text: {template.name}, {submitter.link}, {account.name}": "استخدم نص العناصر النائبة التالية: {template.name}, {submitter.link}, {account.name}",
    "Verify Status": "تحقق من الحالة",
    "Add Radio": "إضافة راديو",
    "Add Multiple": "إضافة متعدد",
    "Activity Type": "نوع النشاط",
    "Browser": "المتصفح",
    "Change Type": "نوع التغيير",
    "No other fields": "لا توجد حقول أخرى",
    "Page Width": "عرض الصفحة",
    "Page Height": "ارتفاع الصفحة",
  },
};
